export const FIELD_CREATE_CUSTOM_SAFE_NAME = 'create.customSafeName'
export const FIELD_CREATE_SUGGESTED_SAFE_NAME = 'create.suggestedSafeName'
export const FIELD_CREATE_SAFE_OWNERS_LIST = 'create.owners'
export const FIELD_NEW_SAFE_THRESHOLD = 'create.newSafeThreshold'
export const FIELD_MAX_OWNER_NUMBER = 'create.maxOwnerNumber'
export const FIELD_NEW_SAFE_PROXY_SALT = 'create.safeCreationSalt'
export const FIELD_NEW_SAFE_GAS_LIMIT = 'create.gasLimit'
export const FIELD_NEW_SAFE_GAS_PRICE = 'create.gasPrice'
export const FIELD_NEW_SAFE_GAS_MAX_PRIO_FEE = 'create.gasMaxPrioFee'
export const FIELD_NEW_SAFE_CREATION_TX_HASH = 'create.safeCreationTxHash'
export const FIELD_NEW_SAFE_OWNER_ENS_LIST = 'create.safeOwnerENSList'

export const FIELD_LOAD_CUSTOM_SAFE_NAME = 'load.customSafeName'
export const FIELD_LOAD_SUGGESTED_SAFE_NAME = 'load.suggestedSafeName'
export const FIELD_LOAD_SAFE_ADDRESS = 'load.safeAddress'
export const FIELD_LOAD_IS_LOADING_SAFE_ADDRESS = 'load.isLoadingSafeAddress'
export const FIELD_LOAD_SAFE_OWNER_LIST = 'load.safeOwnerList'
export const FIELD_SAFE_THRESHOLD = 'load.safeThreshold'

export const FIELD_LOAD_SAFE_OWNER_ENS_LIST = 'load.safeOwnerENSList'
export const FIELD_STARTER_TYPE = 'starterType'

export enum TypeForm {
  open,
  load,
}
export type OwnerFieldItem = {
  nameFieldName: string
  addressFieldName: string
}

export type OwnerFieldListItem = {
  address: string
  name: string
}

export type StarterFormValues = {
  [FIELD_STARTER_TYPE]?: TypeForm
  [FIELD_CREATE_SUGGESTED_SAFE_NAME]: string
  [FIELD_CREATE_CUSTOM_SAFE_NAME]?: string
  [FIELD_NEW_SAFE_THRESHOLD]: number
  [FIELD_CREATE_SAFE_OWNERS_LIST]: Array<OwnerFieldItem>
  [FIELD_NEW_SAFE_OWNER_ENS_LIST]: Record<string, string>
  [FIELD_MAX_OWNER_NUMBER]: number
  [FIELD_NEW_SAFE_PROXY_SALT]: number
  [FIELD_NEW_SAFE_GAS_LIMIT]: number
  [FIELD_NEW_SAFE_GAS_PRICE]: string
  [FIELD_NEW_SAFE_GAS_MAX_PRIO_FEE]: number
  [FIELD_NEW_SAFE_CREATION_TX_HASH]?: string

  [FIELD_LOAD_CUSTOM_SAFE_NAME]?: string
  [FIELD_LOAD_SUGGESTED_SAFE_NAME]: string
  [FIELD_LOAD_SAFE_ADDRESS]?: string
  [FIELD_LOAD_IS_LOADING_SAFE_ADDRESS]: boolean
  [FIELD_LOAD_SAFE_OWNER_LIST]: Array<OwnerFieldListItem>
  [FIELD_LOAD_SAFE_OWNER_ENS_LIST]: Record<string, string>
  [FIELD_SAFE_THRESHOLD]?: number
}

export const SAFE_PENDING_CREATION_STORAGE_KEY = 'NEW_SAFE_PENDING_CREATION_STORAGE_KEY'
